const routes = [
    {
        path: '/customers/inactive-coffee-report',
        name: 'inactive_coffee_customers_report',
        meta: {
            reqAuth: true,
            gate: 'view_customers_order_report'
        },
        component: () => import('../views/InactiveCoffeeCustomersList.vue')
    }
];

export default routes;
